import { isAxiosError, AxiosError, AxiosInstance } from "axios"
import { RequestDetail } from "@/components/request/request"
import AppService from "./app.service"
import { LIVESET } from "@/config/api.endpoints"
import { ApiError } from "@/types/api.types"

export interface LiveSet {
  id?: string
  currency: string
  requestedRate: number
  rate: number
}

export interface LiveSetDetails {
  id?: string
  actualFees: number
  actualTotal: number
  potentialFees: number
  potentialTotal: number
  requestedRate: number
  effectiveRate?: number
  currency: string
  closed?: RequestDetail[]
  fulfilled?: RequestDetail[]
}

export const EMPTY_LIVE_SET_DETAILS: LiveSetDetails = {
  actualFees: 0,
  actualTotal: 0,
  potentialFees: 0,
  potentialTotal: 0,
  requestedRate: AppService.getMinimumRequestAmount(),
  effectiveRate: 0,
  currency: "",
  closed: [] as RequestDetail[],
  fulfilled: [] as RequestDetail[],
}

// TODO: [MVP] implement this
const handleError = (error: unknown) => {
  if (isAxiosError(error)) {
    const axiosError = error as AxiosError<ApiError>
    throw new Error(axiosError.response?.data.message ?? "Unknown error")
  }
  throw error
} 

export const createLiveSetService = (client: AxiosInstance) => {
  return {
    getCurrentLiveSet: async (): Promise<LiveSet | undefined> => {
      try {
        const { data } = await client.get<LiveSet>(LIVESET.BASE)
        return data
      } catch (error) {
        if (isAxiosError(error)) {
          if (error?.response?.status === 404) {
            return undefined
          }
        }
        // TODO: Error handling
        console.error(error)
        throw error
      }
    },

    getCurrentLiveSetDetails: async (): Promise<LiveSetDetails | undefined> => {
      try {
        const { data } = await client.get<LiveSetDetails>(LIVESET.DETAILS)
        return data
      } catch (error) {
        if (isAxiosError(error)) {
          if (error?.response?.status === 404) {
            return undefined
          }
        }
        // TODO: Error handling
        console.error(error)
        throw(error)
      }
    },

    createLiveSet: async (
      amountPerReqst: number,
      locationName: string,
      publishLocation: boolean,
      streaming: boolean,
      // streamingUrl: URL,
      streamingUrl: string,
      filterExplicitRequest: boolean,
    ) => {
      try {
        // TODO: [MVP] Fixup location
        const { data } = await client.post(LIVESET.BASE, {
          "location" : {
            "name": locationName,
            "street0": "123 Main St",
            "street1":"",
            "city": "Atlanta",
            "state": "GA",
            "country": "US"
          },
          "publishLocation" : publishLocation,
          "currency": "usd",
          "requestAmount": amountPerReqst,
          "streaming": streaming,
          "streamingURL": streamingUrl,
          "filterExplicitRequests": filterExplicitRequest,
        })
        return data
      } catch (error) {
        // TODO: Error handling
        console.error(error)
      }
    },

    endCurrentLiveSet: async () => {
      try {
        const { data } = await client.patch(LIVESET.BASE, {})
        return data
      } catch (error) {
        // TODO: Error handling
        console.error(error)
      }
    },
  }
}

export type LiveSetService = ReturnType<typeof createLiveSetService>;
